import React from 'react'
import styles from './Employees.module.css'

import PropTypes from 'prop-types'

import {
    TextField,
    Button,
    MenuItem,
} from '@material-ui/core'
import NumberFormat from 'react-number-format'
class SalaryHistoryForm extends React.Component {
    render() {
        return (
            <div>
                <form>
                    <div className={styles.flex}>
                        <TextField
                            type="date"
                            autoComplete="off"
                            className={styles.leftTextField}
                            variant="outlined"
                            size="small"
                            name="date_effective"
                            fullWidth={true}
                            label="Date Effective"
                            onChange={this.props.handleSalaryChange}
                            required
                            value={this.props.salaries_attributes.date_effective}
                            id="employee-date_effective"
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                        <TextField
                            autoComplete="off"
                            className={styles.rightTextField}
                            variant="outlined"
                            size="small"
                            name="salary_type"
                            fullWidth
                            select
                            label="Salary Type"
                            onChange={this.props.handleSalaryChange}
                            value={this.props.salaries_attributes.salary_type}
                            id="employee-salary_type"
                        >
                            {
                                this.props.salaryTypes.length > 0 ? (
                                    this.props.salaryTypes.map((type, idx) => (
                                        <MenuItem className={styles.capitalize} value={type} key={idx}>{type.replace(/_/g, ' ')}</MenuItem>
                                    ))
                                ) : null
                            }
                        </TextField>
                    </div>
                    <div className={styles.grid}>
                        <NumberFormat
                            customInput={TextField}
                            autoComplete="off"
                            variant="outlined"
                            className={styles.amountBody}
                            size="small"
                            name="rate"
                            fullWidth
                            label="Rate"
                            thousandSeparator={true}
                            onValueChange={this.props.handleRateChange}
                            value={this.props.salaries_attributes.rate}
                            decimalSeparator="."
                            fixedDecimalScale={true}
                            prefix={'₱'}
                        />
                        <TextField
                            autoComplete="off"
                            variant="outlined"
                            size="small"
                            name="remarks"
                            fullWidth
                            label="Remarks"
                            onChange={this.props.handleSalaryChange}
                            value={this.props.salaries_attributes.remarks}
                            id="employee-salary_remarks"
                        />
                    </div>
                    
                </form>
                <div className={styles.actionButton}>
                    <Button variant="outlined" id="ApprovingOfficer-submit" color="primary" onClick={() => this.props.submit()} 
                        disabled={!this.props.salaries_attributes.date_effective || !this.props.salaries_attributes.salary_type || !this.props.salaries_attributes.rate || !this.props.salaries_attributes.remarks}>Save</Button>
                </div>
            </div>
        )
    }
}
export default SalaryHistoryForm

SalaryHistoryForm.propTypes = {
    salaries_attributes: PropTypes.object,
    handleRateChange: PropTypes.func,
    submit: PropTypes.func,
    handleSalaryChange: PropTypes.func,
    salaryTypes: PropTypes.array,
}
